import React from "react";

import { Card, CardProps } from "shared/components";
import { slideInFromTop } from "shared/styles/constants";
import {
  StyledModal,
  ModalStyleProps,
  StyledModalOverlay,
  StyledCloseButton,
  StyledModalContent,
} from "./styles";
import { useCloseOnEscape } from "shared/utils";
import { copy } from "shared/assets";

export interface ModalProps extends CardProps, ModalStyleProps {
  showCloseButton?: boolean;
  handleClose?: () => void;
  isAnimated?: boolean;
  hideMargins?: boolean; // no padding
  isFullscreen?: boolean;
  dataTestId?: string;
}

const root = document.getElementById("root") || {};

export const Modal: React.FC<ModalProps> = ({
  showCloseButton = true,
  handleClose,
  isContained = true,
  isAnimated = true,
  children,
  title,
  hideMargins = false,
  isFullscreen = false,
  dataTestId,
  width,
  ...rest
}) => {
  const requestClose = () => {
    handleClose && handleClose();

    // manual cleanup if react-modal fails
    document.body.classList?.remove("ReactModal__Body--open");
    document.querySelector("#root")?.removeAttribute("aria-hidden");
  };

  // close modal even when focus is not inside modal
  useCloseOnEscape(requestClose);

  return (
    <React.Fragment>
      <StyledModalOverlay />
      <StyledModal
        isOpen
        appElement={root}
        onRequestClose={requestClose}
        isContained={isContained}
        isFullscreen={isFullscreen}
        shouldFocusAfterRender={false}
        contentLabel={copy.a11y.modal}
        width={width}
      >
        <StyledModalContent
          data-testid={dataTestId}
          isFullscreen={isFullscreen}
          {...(isAnimated && slideInFromTop)}
        >
          {showCloseButton && handleClose && (
            <StyledCloseButton
              hasTitle={!title?.length}
              onClick={requestClose}
              data-testid="modal_close"
            />
          )}
          {hideMargins ? (
            children
          ) : (
            <Card title={title} {...rest}>
              {children}
            </Card>
          )}
        </StyledModalContent>
      </StyledModal>
    </React.Fragment>
  );
};
